export enum TableDimension {
    COLUMN = 'COLUMN',
    ROW = 'ROW',
}

export enum TableOptions {
    ADD_AFTER = 'ADD_AFTER',
    ADD_BEFORE = 'ADD_BEFORE',
    REMOVE = 'REMOVE',
    DUPLICATE = 'DUPLICATE',
}

export interface Error {
    rowIndex: number;
    columnIndex: number;
    errorText: string;
    id: string;
    errorValue?: any;
    type?: TableDimension;
}

export enum TableSortOptions {
    ASCENDING_FL = 'ASCENDING_FROM_LEFT',
    DESCENDING_FL = 'DESCENDING_FROM_LEFT',
}

export enum RubricType {
    POINT_BASED = 'pointBased',
    POINT_RANGE = 'pointsRange',
    PERCENTAGE = 'percentage',
    QUALITATIVE = 'qualitative',
    MARKED_QUALITATIVE = 'markedQualitative',
}
